import React from "react";
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className="site-footer">
      <div className="container">
        <div className="row">
          <div className="col futuraPTBold ">
            v3.0.22
            <br />
            210-859-9677<br/>
            &copy; 2026 ADS Sports Complex<br/>
             10251 E Loop 1604 N, Converse, TX 78109
          </div>
          <div className="col">
            <Link to="/TermsConditions">
            Terms & Conditions
            </Link> |&nbsp;
            <Link to="/PrivacyPolicy">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
